import React, {Fragment} from 'react';
import styles from "./sellRecomendation.module.scss";
import {useTranslation} from 'react-i18next';
import {v4 as uuidv4} from "uuid";
import {
  IStrategiesInfo,
  IToOrder,
  RecommendationLabel,
  StateOfTrade,
  StateOfTradeLabel,
  TimeFrames,
  TimeFramesLabel, TradeAction, UserRoles
} from "../../../../shared/types";
import {Button} from "antd";
import advisor from "../../../../assets/images/advisor.png";

interface Props {
  strategiesInfo: IStrategiesInfo | undefined,
  recomends: Record<TradeAction, Partial<Record<string, [string[]]>>>
  strategy: string
  btnRequestLoading: boolean
  registerRequestHandler: (request: IToOrder) => {}
}

const SellRecomendation = ({strategiesInfo, recomends, strategy, btnRequestLoading, registerRequestHandler}: Props) => {

  const {t, i18n} = useTranslation();

  if (!strategiesInfo) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p
          className={styles.strategyTitle}
          title={strategiesInfo[strategy]?.description}>
          <img src={advisor} alt="advisor"/>
          {/*//@ts-ignore*/}
          {t('AdvisorsOrderStrategy')}
          - <span>{strategiesInfo[strategy].label}</span>
        </p>
        {recomends.SELL[strategy]?.map((elem) => {
          const price = elem[5]
          const date = elem[6]
          return <Fragment key={uuidv4()}>
            <p className={styles.tickerTitle}>{elem[0]}</p>
            <p className={styles.otherTitle}>
              {/*//@ts-ignore*/}
              {t('AdvisorsOrderTimeframe')} - {TimeFramesLabel[elem[1] as TimeFrames]}
            </p>
            <p className={styles.otherTitle}>
              {/*//@ts-ignore*/}
              {t('AdvisorsOrderAction')} - {t(RecommendationLabel.SELL)} / {t(StateOfTradeLabel[elem[2] as StateOfTrade])}
            </p>
            {/*//@ts-ignore*/}
            <p className={styles.otherTitle}>{t('AdvisorsOrderSpecificities')} - {elem[4]}</p>
            <p className={styles.otherTitle}
              /*//@ts-ignore*/
               title={t('AdvisorsOrderVolumeDescription')}
            >
              {/*//@ts-ignore*/}
              {t('AdvisorsOrderVolume')} - {elem[3]}
            </p>
            {/*//@ts-ignore*/}
            <p className={styles.otherTitle}>{t('AdvisorsOrderPrice')} - {price}</p>
            <Button size={'small'} shape={'round'} loading={btnRequestLoading}
                    onClick={() => registerRequestHandler({
                      strategy: strategy,
                      ticker: elem[0],
                      timeframe: elem[1] as TimeFrames,
                      price: price.toString(),
                      stopLoss: '',
                      takeProfit: '',
                      date: date,
                      actionType: TradeAction.SELL,
                      action: elem[2] as StateOfTrade,
                      value: Number(elem[3]),
                      specificity: elem[4]
                    })}>
              {/*//@ts-ignore*/}
              {t('AdvisorsOrderSubmitOrder')}
            </Button>
          </Fragment>
        })}
      </div>
    </div>
  );
};

export default SellRecomendation;